import styled from 'styled-components';
import Colors from 'assets/Colors';
import wallpaper from '../assets/images/Background.svg';

const PageContainer = styled.div`
  min-height: 100vh;
  height: 100%;
  margin: 0 auto;
  background-image: url("${wallpaper}");
  padding: 0 122px;
  @media (max-width: 640px) {
    padding: 0 10px;
    width: 97%;
  }
`;

const container = styled.div`
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
`;

const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 38px;
  height: 100px;
`;
const PageContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80vh;
  @media (max-width: 640px) {
    flex-direction: column-reverse;
    justify-content: center;
    margin: 4px;
    width: 100%;
    display: block;
    margin-top: 50px;
  }
`;
const Logo = styled.img`
  width: 154px;
  height: 53px;
`;

const containerButton = styled.div`
  display: flex;
  // justify-content: space-between;
  width: 100%;
  height: 100%;
  @media (max-width: 640px) {
    width: 98%;
  }
`;
const textContainer = styled.div``;

const textPrimary = styled.p`
  margin-bottom: 29px;
  font-size: 48px;
  line-height: 48px;
  font-weight: bold;
  letter-spacing: 0.02em;
  color: ${Colors.text_primary};
`;
const textSecondary = styled.p`
  margin-bottom: 29px;
  font-size: 48px;
  line-height: 48px;
  letter-spacing: 0.02em;
  color: ${Colors.text_primary};
`;
const textTertiary = styled.p`
  margin-bottom: 57px;
  font-size: 18px;
  line-height: 18px;
  font-weight: light;
  letter-spacing: 0.02em;
  color: ${Colors.text_primary};
`;
const Button = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 250px;
    height: 60px;
    background: ${Colors.text_primary};
    border: none;
    border-radius: 5px;
    color: #fff;
    font-size: 24px;
    font-weight: semibold;
    border: 1px solid ${Colors.primary};
    cursor: pointer;
    outline: none;
    transition: all 0.3s;
    &:hover {
        color: #fff;
        }
    }
`;
const linkIcon = styled.a`
    cursor: pointer;
    outline: none;
    margin-right: 13px;
    transition: all 0.3s;
    z-index: 1;
    &:hover {
       transform: scale(1.1);
        }
    }
`;

const textButton = styled.p`
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: ${Colors.text_on_primary};
`;
const PageFooter = styled.div`
  // position: relative;
  margin-top: 180px;
  display: flex;
  // height: 10vh;
  font-size: 14px;
  font-weight: 300;
  color: ${Colors.text_secondary};
`;

export default {
  PageContainer,
  container,
  PageHeader,
  PageContent,
  PageFooter,
  Logo,
  containerButton,
  textPrimary,
  textSecondary,
  textTertiary,
  textButton,
  Button,
  textContainer,
  linkIcon,
};
